module.exports = __webpack_public_path__ + "media/images/pricing/pricing-ultimate-1a900be7d00b7c81ed47f8e29a53dbc4.svg";